import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from 'primereact/multiselect';

function UpdateShareholderDetail() {
    const { id } = useParams(); // Get the project ID from the URL
    const navigate = useNavigate();
    const [shareholder, setShareholder] = useState({});
    const [activeLanguage, setActiveLanguage] = useState('en');
    const [spanishData, setSpanishData] = useState({ title: '', description: '', led: '', space: '' });
    const [newImages, setNewImages] = useState([]);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [portfolios, setPortfolios] = useState([]);
    const [selectedPortfolios, setSelectedPortfolios] = useState([]);
    const [selectedSpanishPortfolios, setSelectedSpanishPortfolios] = useState([]);


    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const fileInputRef = useRef(null);
    const featuredImageRef = useRef(null);

    const [services, setServices] = useState([
        { title: '', description: '', image: null }
    ]);

    const [reviews, setReviews] = useState([
        { title: '', description: '', image: null }
    ]);

    const [spanishServices, setSpanishServices] = useState([
        { title: '', description: '', image: null }
    ]);

    const [spanishReviews, setSpanishReviews] = useState([
        { title: '', description: '', image: null }
    ]);

    // Services
    const handleServicesChange = (index, event) => {
        const newFields = services.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: event.target.value };
            }
            return field;
        });
        setServices(newFields);
    };

    const addServicesFields = () => {
        setServices([...services, { title: '', description: '', image: null }]);
    };

    const removeServicesFields = (index) => {
        const newFields = services.filter((field, fieldIndex) => index !== fieldIndex);
        setServices(newFields);
    };

    const handleServicesImageChange = (index, event) => {
        const image = event.target.files;
        const newFields = services.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: image[0] };
            }
            return field;
        });

        setServices(newFields);
    };

    // Reviews change
    const handleReviewsChange = (index, event) => {
        const newFields = reviews.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: event.target.value };
            }
            return field;
        });
        setReviews(newFields);
    };

    const addReviewsFields = () => {
        setReviews([...reviews, { title: '', description: '', image: null }]);
    };

    const removeReviewsFields = (index) => {
        const newFields = reviews.filter((field, fieldIndex) => index !== fieldIndex);
        setReviews(newFields);
    };

    const handleReviewsImageChange = (index, event) => {
        const image = event.target.files;
        const newFields = reviews.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: image[0] };
            }
            return field;
        });

        setReviews(newFields);
    };

    // Spanish Services
    const handleSpanishServicesChange = (index, event) => {
        const newFields = spanishServices.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: event.target.value };
            }
            return field;
        });
        setSpanishServices(newFields);
    };

    const addSpanishServicesFields = () => {
        setSpanishServices([...spanishServices, { title: '', description: '', image: null }]);
    };

    const removeSpanishServicesFields = (index) => {
        const newFields = spanishServices.filter((field, fieldIndex) => index !== fieldIndex);
        setSpanishServices(newFields);
    };

    const handleSpanishServicesImageChange = (index, event) => {
        const image = event.target.files;
        const newFields = spanishServices.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: image[0] };
            }
            return field;
        });

        setSpanishServices(newFields);
    };

    // Spanish Reviews
    const handleSpanishReviewsChange = (index, event) => {
        const newFields = spanishReviews.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: event.target.value };
            }
            return field;
        });
        setSpanishReviews(newFields);
    };

    const addSpanishReviewsFields = () => {
        setSpanishReviews([...spanishReviews, { title: '', description: '', image: null }]);
    };

    const removeSpanishReviewsFields = (index) => {
        const newFields = spanishReviews.filter((field, fieldIndex) => index !== fieldIndex);
        setSpanishReviews(newFields);
    };

    const handleSpanishReviewsImageChange = (index, event) => {
        const image = event.target.files;
        const newFields = spanishReviews.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: image[0] };
            }
            return field;
        });

        setSpanishReviews(newFields);
    };

    const fetchPortfolios = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-portfolios`, { withCredentials: true });

            if (response.data) {
                setPortfolios(response.data);
            }

        } catch (err) {
            console.log('Failed to fetch portfolios');
        }
    };

    const handleImageUpload = async (image) => {
        const formData = new FormData();
        formData.append('image', image);

        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/upload-image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data?.image; // Assuming your API returns the image URL
        } catch (error) {
            console.error('Image upload failed:', error);

            return null;
        }
    };

    useEffect(() => {
        const fetchShareholderDetails = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-shareholder-admin/${id}`, { withCredentials: true });
                setShareholder(response.data);
                setServices(response.data?.services || [{ title: '', description: '', image: null }]);
                setReviews(response.data?.reviews || [{ title: '', description: '', image: null }]);
                setSelectedPortfolios(response.data?.portfolios || []);
                setSpanishServices(response.data?.spanishData?.services || [{ title: '', description: '', image: null }]);
                setSpanishReviews(response.data?.spanishData?.reviews || [{ title: '', description: '', image: null }]);
                setSelectedSpanishPortfolios(response.data?.spanishData?.portfolios || []);
                setSpanishData({
                    title: response.data?.spanishData?.title || '',
                    description: response.data?.spanishData?.description || '',
                    led: response.data?.spanishData?.led || '',
                    space: response.data?.spanishData?.space || '',
                    // slug: response.data?.spanishData?.slug || ''
                });

            } catch (err) {
                setError('Failed to fetch shareholder details');

                setTimeout(() => {
                    setError('');
                }, 3000);
            }
        };

        fetchShareholderDetails();
    }, [id]);

    const handleRemoveImage = async (imageName, repeaterName = null, index = 0) => {
        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-shareholder`, {
                shareholderId: shareholder._id,
                imageName
            }, { withCredentials: true });

            if (response.status === 200) {
                // Update project state
                setShareholder(prevShareholder => {
                    const updatedImages = prevShareholder.clients.filter(image => image !== imageName);
                    return {
                        ...prevShareholder,
                        clients: updatedImages,
                        featuredImage: prevShareholder.featuredImage === imageName ? null : prevShareholder.featuredImage,
                    };
                });

                if (repeaterName && repeaterName === "services") {
                    let updatedContent = services;
                    updatedContent[index]['image'] = null;
                    setServices(updatedContent);
                }

                if (repeaterName && repeaterName === "reviews") {
                    let updatedContent = services;
                    updatedContent[index]['image'] = null;
                    setReviews(updatedContent);
                }

            } else {
                console.error('Failed to remove image');
            }
        } catch (err) {
            console.error('Error removing image:', err);
        }
    };

    const handleNewImageChange = (e) => {
        setNewImages(e.target.files); // Set new images to be uploaded
    };

    const handleFeaturedImageChange = (e) => {
        setFeaturedImage(e.target.files[0]); // Set the featured image
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append('title', shareholder.title);
        formData.append('description', shareholder.description);
        formData.append('led', shareholder.led);
        formData.append('space', shareholder.space);
        // if (shareholder.slug) {
        //     formData.append('slug', shareholder.slug);
        // }
        formData.append('isFeatured', shareholder.isFeatured);
        formData.append('isHomePageFeatured', shareholder.isHomePageFeatured);

        if(selectedPortfolios.length > 0){
            formData.append('portfolios', JSON.stringify(selectedPortfolios));
        }

        if(selectedSpanishPortfolios.length > 0){
            formData.append('spanishPortfolios', JSON.stringify(selectedSpanishPortfolios));
        }

        // Add new images for gallery
        for (const image of newImages) {
            formData.append('clients', image);
        }

        // Add the featured image if selected
        if (featuredImage) {
            formData.append('featuredImage', featuredImage);
        }

        // English Services
        if (services.length > 0) {
            var updatedServices = [];
            await Promise.all(services.map(async (item, index) => {
                if (item?.image) {
                    if (typeof item?.image == "object") {
                        var imageData = await handleImageUpload(item?.image);
                        updatedServices.push({ title: item.title, description: item.description, image: imageData });
                    } else {
                        updatedServices.push({ title: item.title, description: item.description, image: item?.image });
                    }
                } else {
                    updatedServices.push({ title: item.title, description: item.description, image: null });
                }
            }));
            formData.append('services', JSON.stringify(updatedServices));
        }

        // English Reviews
        if (reviews.length > 0) {
            var updatedReviews = [];
            await Promise.all(reviews.map(async (item, index) => {
                if (item?.image) {
                    if (typeof item?.image == "object") {
                        var imageData = await handleImageUpload(item?.image);
                        updatedReviews.push({ title: item.title, description: item.description, image: imageData });
                    } else {
                        updatedReviews.push({ title: item.title, description: item.description, image: item?.image });
                    }
                } else {
                    updatedReviews.push({ title: item.title, description: item.description, image: null });
                }
            }));
            formData.append('reviews', JSON.stringify(updatedReviews));
        }

        // Spanish Services
        if (spanishServices.length > 0) {
            var updatedSpanishServices = [];
            await Promise.all(spanishServices.map(async (item, index) => {
                if (item?.image) {
                    if (typeof item?.image == "object") {
                        var imageData = await handleImageUpload(item?.image);
                        updatedSpanishServices.push({ title: item.title, description: item.description, image: imageData });
                    } else {
                        updatedSpanishServices.push({ title: item.title, description: item.description, image: item?.image });
                    }
                } else {
                    updatedSpanishServices.push({ title: item.title, description: item.description, image: null });
                }
            }));
            formData.append('spanishServices', JSON.stringify(updatedSpanishServices));
        }

        // Spanish Reviews
        if (spanishReviews.length > 0) {
            var updatedSpanishReviews = [];
            await Promise.all(spanishReviews.map(async (item, index) => {
                if (item?.image) {
                    if (typeof item?.image == "object") {
                        var imageData = await handleImageUpload(item?.image);
                        updatedSpanishReviews.push({ title: item.title, description: item.description, image: imageData });
                    } else {
                        updatedSpanishReviews.push({ title: item.title, description: item.description, image: item?.image });
                    }
                } else {
                    updatedSpanishReviews.push({ title: item.title, description: item.description, image: null });
                }
            }));
            formData.append('spanishReviews', JSON.stringify(updatedSpanishReviews));
        }

        // Spanish translation payload
        formData.append('spanishData', JSON.stringify({
            language: 'es',
            title: spanishData.title || '',
            description: spanishData.description || '',
            led: spanishData.led || '',
            space: spanishData.space || '',
            clients: spanishData.clients || [],
            services: [], // Will be populated separately
            portfolios: selectedSpanishPortfolios || [],
            reviews: [], // Will be populated separately
            // slug: spanishData.slug || ''
        }));

        try {
            const response = await axios.put(`${config.BASE_URL}/api/admin/update-shareholder/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            });

            setShareholder(response.data.shareholder);
            setServices(response.data.shareholder?.services);
            setReviews(response.data.shareholder?.reviews);

            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            if (featuredImageRef.current) {
                featuredImageRef.current.value = '';
            }

            setFeaturedImage(null);
            setSuccessMessage('Shareholder updated successfully!');

            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);

        } catch (err) {
            setError('Failed to update shareholder');

            setTimeout(() => {
                setError('');
            }, 3000);
        }
    }

    useEffect(() => {
        fetchPortfolios();
    }, []);

    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Edit Shareholder</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                {shareholder ? (
                    <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                        <div className="update_details_wrap">
                            {/* Language Tabs */}
                            <div className="language-tabs" style={{ marginBottom: '20px' }}>
                                <button 
                                    type="button" 
                                    className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                                    onClick={() => setActiveLanguage('en')}
                                    style={{
                                        padding: '10px 20px',
                                        marginRight: '10px',
                                        backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                                        color: activeLanguage === 'en' ? 'white' : 'black',
                                        border: '1px solid #ddd',
                                        cursor: 'pointer'
                                    }}
                                >
                                    English
                                </button>
                                <button 
                                    type="button" 
                                    className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                                    onClick={() => setActiveLanguage('es')}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                                        color: activeLanguage === 'es' ? 'white' : 'black',
                                        border: '1px solid #ddd',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Spanish
                                </button>
                            </div>

                            <div className="form-group">
                                {activeLanguage === 'en' && (
                                    <>
                                        <label>Title (English)</label>
                                        <input
                                            type="text"
                                            value={shareholder.title || ''}
                                            onChange={(e) => setShareholder({ ...shareholder, title: e.target.value })}
                                        />
                                    </>
                                )}
                                {activeLanguage === 'es' && (
                                    <>
                                        <label>Title (Spanish)</label>
                                        <input
                                            type="text"
                                            value={spanishData.title}
                                            onChange={(e) => setSpanishData({ ...spanishData, title: e.target.value })}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="form-group">
                                {activeLanguage === 'en' && (
                                    <>
                                        <label>Description (English)</label>
                                        <input
                                            type="text"
                                            value={shareholder.description || ''}
                                            onChange={(e) => setShareholder({ ...shareholder, description: e.target.value })}
                                        />
                                    </>
                                )}
                                {activeLanguage === 'es' && (
                                    <>
                                        <label>Description(Spanish)</label>
                                        <input
                                            type="text"
                                            value={spanishData.description}
                                            onChange={(e) => setSpanishData({ ...spanishData, description: e.target.value })}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="form-group">
                                {activeLanguage === 'en' && (
                                    <>
                                        <label>Led (English)</label>
                                        <input
                                            type="text"
                                            value={shareholder.led || ''}
                                            onChange={(e) => setShareholder({ ...shareholder, led: e.target.value })}
                                        />
                                    </>
                                )}
                                {activeLanguage === 'es' && (
                                    <>
                                        <label>Led (Spanish)</label>
                                        <input
                                            type="text"
                                            value={spanishData.led}
                                            onChange={(e) => setSpanishData({ ...spanishData, led: e.target.value })}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="form-group">
                                {activeLanguage === 'en' && (
                                    <>
                                        <label>Space (English)</label>
                                        <input
                                            type="text"
                                            value={shareholder.space || ''}
                                            onChange={(e) => setShareholder({ ...shareholder, space: e.target.value })}
                                        />
                                    </>
                                )}
                                {activeLanguage === 'es' && (
                                    <>
                                        <label>Space  (Spanish)</label>
                                        <input
                                            type="text"
                                            value={spanishData.space}
                                            onChange={(e) => setSpanishData({ ...spanishData, space: e.target.value })}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="form-group">
                                {/* {activeLanguage === 'en' && (
                                    <>
                                        <label>Slug (English)</label>
                                        <input
                                            type="text"
                                            value={shareholder.slug || ''}
                                            onChange={(e) => setShareholder({ ...shareholder, slug: e.target.value })}
                                            placeholder="url-friendly-slug"
                                        />
                                    </>
                                )} */}
                                {/* {activeLanguage === 'es' && (
                                    <>
                                        <label>Slug (Spanish)</label>
                                        <input
                                            type="text"
                                            value={spanishData.slug}
                                            onChange={(e) => setSpanishData({ ...spanishData, slug: e.target.value })}
                                            placeholder="slug-amigable"
                                        />
                                    </>
                                )} */}
                            </div>

                            {activeLanguage === 'es' && (
                                <div className="form-group">
                                    <div className="add_field textareaField">
                                        <h2>Select Portfolios (Spanish)</h2>
                                        <MultiSelect 
                                            value={selectedSpanishPortfolios} 
                                            onChange={(e) => setSelectedSpanishPortfolios(e.value)} 
                                            options={portfolios} 
                                            optionLabel="title" 
                                            placeholder="Seleccionar Portafolios" 
                                            maxSelectedLabels={3} 
                                            className="w-full md:w-20rem" 
                                        />
                                    </div>
                                </div>
                            )}

                            {activeLanguage === 'es' && (
                                <div className="add_field textareaField repeaterFields">
                                    <h2><b>Services (Spanish)</b></h2>
                                    {spanishServices && spanishServices.length > 0 && spanishServices.map((field, index) => (
                                        <div key={index} className="singleReapterFieldContent update">
                                            <div className="add_field">
                                                <div className="form-group">
                                                    <h2>Title</h2>
                                                    <input
                                                        name="title"
                                                        type="text"
                                                        value={field.title}
                                                        placeholder="Título"
                                                        onChange={(event) => handleSpanishServicesChange(index, event)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="add_field">
                                                <div className="form-group">
                                                    <h2>Description</h2>
                                                    <input
                                                        name="description"
                                                        type="text"
                                                        value={field.description}
                                                        placeholder="Descripción"
                                                        onChange={(event) => handleSpanishServicesChange(index, event)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="add_field">
                                                <h2>Image</h2>
                                                <div className="form-group">
                                                    <div className="file-upload">
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="image"
                                                            onChange={(event) => handleSpanishServicesImageChange(index, event)}
                                                        />
                                                        <i className="fa fa-camera i-pic-upload"></i>
                                                    </div>
                                                </div>

                                                {field?.image && typeof field?.image !== "object" && (
                                                    <div className="detail_item_inner gallery_inner">
                                                        <div className="detail_img_item">
                                                            <div className="banner_img_wrap">
                                                                <img src={`${config.BASE_URL}${field?.image}`} alt="Featured" />
                                                            </div>
                                                            <button className="remove_btn" type="button" onClick={() => handleRemoveImage(field?.image, "spanishServices", index)}>Eliminar</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <button type="button" onClick={() => removeSpanishServicesFields(index)}>
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                    <button type="button" onClick={addSpanishServicesFields}>Agregar Más</button>
                                </div>
                            )}

                            {activeLanguage === 'es' && (
                                <div className="add_field textareaField repeaterFields">
                                    <h2><b>Reviews (Spanish)</b></h2>
                                    {spanishReviews && spanishReviews.length > 0 && spanishReviews.map((field, index) => (
                                        <div key={index} className="singleReapterFieldContent update">
                                            <div className="add_field">
                                                <div className="form-group">
                                                    <h2>Reviews</h2>
                                                    <input
                                                        name="Title"
                                                        type="text"
                                                        value={field.title}
                                                        placeholder="Título"
                                                        onChange={(event) => handleSpanishReviewsChange(index, event)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="add_field">
                                                <div className="form-group">
                                                    <h2>Description</h2>
                                                    <input
                                                        name="description"
                                                        type="text"
                                                        value={field.description}
                                                        placeholder="Descripción"
                                                        onChange={(event) => handleSpanishReviewsChange(index, event)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="add_field">
                                                <h2>Image</h2>
                                                <div className="form-group">
                                                    <div className="file-upload">
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="image"
                                                            onChange={(event) => handleSpanishReviewsImageChange(index, event)}
                                                        />
                                                        <i className="fa fa-camera i-pic-upload"></i>
                                                    </div>
                                                </div>

                                                {field?.image && typeof field?.image !== "object" && (
                                                    <div className="detail_item_inner gallery_inner">
                                                        <div className="detail_img_item">
                                                            <div className="banner_img_wrap">
                                                                <img src={`${config.BASE_URL}${field?.image}`} alt="Featured" />
                                                            </div>
                                                            <button className="remove_btn" type="button" onClick={() => handleRemoveImage(field?.image, "spanishReviews", index)}>Remove</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <button type="button" onClick={() => removeSpanishReviewsFields(index)}>
                                               Remove
                                            </button>
                                        </div>
                                    ))}
                                    <button type="button" onClick={addSpanishReviewsFields}>Agregar Más</button>
                                </div>
                            )}

                            <div className="form-group">
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">
                                        <div className="upload_item">
                                            <label>Featured Image</label>
                                            <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
                                        </div>
                                        <div className="detail_img_grid">
                                            {shareholder.featuredImage ? (
                                                <div className="detail_img_item">
                                                    <div className="banner_img_wrap">
                                                        <img src={`${config.BASE_URL}${shareholder.featuredImage}`} alt="Featured" />
                                                    </div>
                                                    <button className="remove_btn" type="button" onClick={() => handleRemoveImage(shareholder.featuredImage)}>Remove</button>
                                                </div>
                                            ) : (
                                                <p>No image available.</p>
                                            )}
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="form-group">
                                <div className="form-group">
                                    <label>Clients</label>
                                    <input type="file" multiple onChange={handleNewImageChange} ref={fileInputRef} />
                                </div>
                                <div className="detail_item_inner gallery_inner">
                                    <div className="detail_img_grid">
                                        {shareholder?.clients && shareholder.clients.map((image, index) => (
                                            <div className="detail_image_item" key={index}>
                                                <div className="detail_img_item galleryImages">
                                                    <img src={`${config.BASE_URL}${image}`} alt={`shareholder ${index}`} />
                                                </div>
                                                <button className="remove_btn" type="button" onClick={() => handleRemoveImage(image)}>Remove</button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="add_field textareaField repeaterFields">
                                <h2><b>Services</b></h2>
                                {services && services.length > 0 && services.map((field, index) => (
                                    <div key={index} className="singleReapterFieldContent update">
                                        <div className="add_field">
                                            <div className="form-group">
                                                <h2>Title</h2>
                                                <input
                                                    name="title"
                                                    type="text"
                                                    value={field.title}
                                                    placeholder="Title"
                                                    onChange={(event) => handleServicesChange(index, event)}
                                                />
                                            </div>
                                        </div>

                                        <div className="add_field">
                                            <div className="form-group">
                                                <h2>Description</h2>
                                                <input
                                                    name="description"
                                                    type="text"
                                                    value={field.description}
                                                    placeholder="Description"
                                                    onChange={(event) => handleServicesChange(index, event)}
                                                />
                                            </div>
                                        </div>

                                        <div className="add_field">
                                            <h2>Image</h2>
                                            <div className="form-group">
                                                <div className="file-upload">
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="image"
                                                        onChange={(event) => handleServicesImageChange(index, event)}
                                                    />
                                                    <i className="fa fa-camera i-pic-upload"></i>
                                                </div>
                                            </div>

                                            {field?.image && typeof field?.image !== "object" && (

                                                <div className="detail_item_inner gallery_inner">
                                                    <div className="detail_img_item">
                                                        <div className="banner_img_wrap">
                                                            <img src={`${config.BASE_URL}${field?.image}`} alt="Featured" />
                                                        </div>
                                                        <button className="remove_btn" type="button" onClick={() => handleRemoveImage(field?.image, "services", index)}>Remove</button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <button type="button" onClick={() => removeServicesFields(index)}>
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button type="button" onClick={addServicesFields}>Add More</button>
                            </div>

                            <div className="add_field textareaField repeaterFields">
                                <h2><b>Reviews</b></h2>
                                {reviews && reviews.length > 0 && reviews.map((field, index) => (
                                    <div key={index} className="singleReapterFieldContent update">
                                        <div className="add_field">
                                            <div className="form-group">
                                                <h2>Title</h2>
                                                <input
                                                    name="title"
                                                    type="text"
                                                    value={field.title}
                                                    placeholder="Title"
                                                    onChange={(event) => handleReviewsChange(index, event)}
                                                />
                                            </div>
                                        </div>

                                        <div className="add_field">
                                            <div className="form-group">
                                                <h2>Description</h2>
                                                <input
                                                    name="description"
                                                    type="text"
                                                    value={field.description}
                                                    placeholder="Description"
                                                    onChange={(event) => handleReviewsChange(index, event)}
                                                />
                                            </div>
                                        </div>

                                        <div className="add_field">
                                            <h2>Image</h2>
                                            <div className="form-group">
                                                <div className="file-upload">
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="image"
                                                        onChange={(event) => handleReviewsImageChange(index, event)}
                                                    />
                                                    <i className="fa fa-camera i-pic-upload"></i>
                                                </div>
                                            </div>

                                            {field?.image && typeof field?.image !== "object" && (

                                                <div className="detail_item_inner gallery_inner">
                                                    <div className="detail_img_item">
                                                        <div className="banner_img_wrap">
                                                            <img src={`${config.BASE_URL}${field?.image}`} alt="Featured" />
                                                        </div>
                                                        <button className="remove_btn" type="button" onClick={() => handleRemoveImage(field?.image, "reviews", index)}>Remove</button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <button type="button" onClick={() => removeReviewsFields(index)}>
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button type="button" onClick={addReviewsFields}>Add More</button>
                            </div>

                            <div className="form-group">
                                <div className="add_field textareaField">
                                    <h2>Select Portfolios</h2>
                                    <MultiSelect 
                                        value={selectedPortfolios} 
                                        onChange={(e) => setSelectedPortfolios(e.value)} 
                                        options={portfolios} 
                                        optionLabel="title" 
                                        placeholder="Select Portfolios" 
                                        maxSelectedLabels={3} 
                                        className="w-full md:w-20rem" 
                                    />
                                </div>
                            </div>

                            <div className="add_field checkbox_field">
                                <Checkbox
                                    onChange={(e) => setShareholder({ ...shareholder, isFeatured: e.checked })}
                                    checked={shareholder.isFeatured}
                                ></Checkbox>
                                <h4>Is Featured?</h4>
                            </div>

                            <div className="add_field checkbox_field">
                                <Checkbox
                                    onChange={(e) => setShareholder({ ...shareholder, isHomePageFeatured: e.checked })}
                                    checked={shareholder.isHomePageFeatured}
                                ></Checkbox>
                                <h4>Is HomePage Featured?</h4>
                            </div>

                            <div className="update_btn_wrap">
                                <button className="update_btn" type="submit">Update Shareholder</button>
                            </div>
                            {successMessage && <p className="success-message">{successMessage}</p>}
                            {error && <p className="error-message">{error}</p>}
                        </div>
                    </form>
                ) : (
                    <h5>Shareholder not found!</h5>
                )}
            </div>
        </div>
    );
}

export default UpdateShareholderDetail;
